module.exports = __webpack_public_path__ + "static/img/KR@3x.e19e9fcd.png";